import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isRecurring } = {}) => ({
  clickable: { cursor: 'pointer' },
  orderTitle: {
    marginBottom: isRecurring ? theme.spacing(2) : theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(2),
      marginBottom: isRecurring ? theme.spacing(3) : theme.spacing(4),
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(1),
    },
  },
  orderDetails: {
    '& #reorder': {
      width: 110,
    },
    [theme.breakpoints.down('lg')]: {
      minHeight: '89vh',
      display: 'flex',
      flexDirection: 'column',
      '& #reorder': {
        height: 44,
      },
    },
    [theme.breakpoints.down('md')]: {
      '& #reorder': {
        width: '100%',
      },
    },
  },
  breadCrumbs: {
    color: theme.palette.darkGrey,
    ...theme.typography.h3,
    '& > * > :last-child': {
      color: theme.palette.grey2,
    },
  },
}));
